import { Button } from '@chakra-ui/button';
import { FormControl, FormLabel } from '@chakra-ui/form-control';
import { Input } from '@chakra-ui/input';
import { Box, Flex } from '@chakra-ui/layout';
import { Select } from '@chakra-ui/select';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useEffect } from 'react';
import { useState } from 'react';
import InputFloating from '../../../components/InputFloating';

const schema = yup.object().shape({
  numero_pedido: yup.string().test('len', 'Mínimo 6 caracteres', (val) => {
    if (val) {
      return val.length >= 6;
    }
    return true;
  }),
});

export function Filtro({ getOrdemProduction }) {
  const { handleSubmit, register, formState } = useForm({
    resolver: yupResolver(schema),
  });

  function getDataFilter(dados) {
    getOrdemProduction(dados);
  }

  return (
    <FormControl
      py="1rem"
      as="form"
      onSubmit={handleSubmit(getDataFilter)}
      mt="1rem"
    >
      <Flex
        flexDir="column"
        align="center"
        w="full"
        px="6rem"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Flex align="start" justify="space-between" gap="1rem" w="full">
          <Flex gap={5}>
            <InputFloating
              type="number"
              label="Nº Pedido"
              variant="flushed"
              {...register('numero_pedido')}
            />
            {/*<InputFloating type="text" label="Impressão" variant="flushed" {...register("impressao")} />*/}
          </Flex>
          <Box
            display="flex"
            flex={1}
            gap="1rem"
            alignItems="start"
            justifyContent="center"
          >
            <Flex alignItems="start" flexDir="column">
              <InputFloating
                label="De:"
                type="date"
                {...register('data_entrada')}
                variant="flushed"
              />
            </Flex>
            <Flex ml="50px" alignItems="start" flexDir="column">
              <InputFloating
                label="Até:"
                type="date"
                {...register('data_saida')}
                variant="flushed"
              />
            </Flex>
          </Box>
          {/*<InputFloating type="text" label="Prazo" variant="flushed" {...register("prazo")} maxW={"150px"} />*/}
          <Select
            placeholder="Situação"
            {...register('situacao')}
            maxW={'150px'}
          >
            <option value="3">Pendente</option>
            <option value="4">Finalizado</option>
          </Select>
        </Flex>
        <Button
          colorScheme="blue"
          variant="outline"
          mt="1rem"
          type="submit"
          px="2rem"
          bg="#378BBF"
          color="white"
          _hover={{ bg: '#378BBF' }}
        >
          Filtrar
        </Button>
      </Flex>
    </FormControl>
  );
}
